import React from 'react';

import { Content } from 'LegacySBCRA/Content/Content';

import { ContentArea, ExpandableSection } from '../../../fastlane/expandableSection/ExpandableSection';

import styles from './ExpandableContentWrapper.scss';

type ExpandableContentWrapperProps = {
  analyticsEvents: {
    onButtonClick: ({ isOpen, label }: { isOpen: boolean; label: string }) => void;
    onLoad: () => void;
  };
  faq: ContentArea[];
  faqTitle: string;
};

export const ExpandableContentWrapper = ({ analyticsEvents, faq, faqTitle }: ExpandableContentWrapperProps) => (
  <Content className={styles.expandableSectionWrapper}>
    <ExpandableSection
      {...{ analyticsEvents }}
      isCompactWithoutImage
      className={styles.expandableSection}
      content={faq}
      title={faqTitle}
    />
  </Content>
);
